
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const GasEquipmentHealth = () => {
  return (
    <AnimatedCard 
      animation="fade-up" 
      delay={800}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Equipment Health</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="space-y-4">
          <div>
            <div className="flex justify-between items-center mb-1">
              <span className="text-sm font-medium">Pressure Regulators</span>
              <span className="text-sm font-medium text-green-500">94%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
              <div className="bg-green-500 h-2.5 rounded-full" style={{ width: '94%' }}></div>
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center mb-1">
              <span className="text-sm font-medium">Flow Meters</span>
              <span className="text-sm font-medium text-green-500">91%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
              <div className="bg-green-500 h-2.5 rounded-full" style={{ width: '91%' }}></div>
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center mb-1">
              <span className="text-sm font-medium">Gas Meters</span>
              <span className="text-sm font-medium text-amber-500">86%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
              <div className="bg-amber-500 h-2.5 rounded-full" style={{ width: '86%' }}></div>
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center mb-1">
              <span className="text-sm font-medium">Leak Detectors</span>
              <span className="text-sm font-medium text-green-500">92%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
              <div className="bg-green-500 h-2.5 rounded-full" style={{ width: '92%' }}></div>
            </div>
          </div>
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default GasEquipmentHealth;
